/**
 * URLs that indicate the user has NOT uploaded their own image for a particular
 * slot yet — the editor is still showing the canonical default. Upload-component
 * UIs use these to surface a "drop your image here" placeholder even though the
 * actual scene viewport renders the default image normally, so users notice the
 * slot is replaceable.
 *
 * The Background slot is intentionally NOT listed here — its dropzone keeps its
 * existing behaviour (preview of the default image, no placeholder).
 */
export const DEFAULT_SCREEN_IMAGE_URL = '/sample.jpg'

export const DEFAULT_SPRITE_IMAGE_URL = '/logo-gradient.svg'
